import { base64UrlToBase64 } from './base64UrlToBase64';

export const decodePasswordResetTokenExpiry = (
  token: string | null | undefined,
): Date | undefined => {
  if (!token) return undefined;

  try {
    const json = decodeURIComponent(
      atob(base64UrlToBase64(token))
        .split('')
        .map((char) => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );

    const { expires_at: expiresAt } = JSON.parse(json) as {
      expires_at?: unknown;
    };
    if (typeof expiresAt !== 'string') return undefined;

    const parsed = new Date(expiresAt);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  } catch {
    return undefined;
  }
};
